export const CATEGORIES = [
  { value: "conflict", label: "Workplace Conflict", icon: "Users", description: "Tension or disagreement with a colleague, team, or leader." },
  { value: "policy_question", label: "Policy Question", icon: "HelpCircle", description: "A question about how a Patria policy applies to you." },
  { value: "harassment", label: "Harassment", icon: "ShieldAlert", description: "Unwelcome conduct that feels intimidating or hostile." },
  { value: "discrimination", label: "Discrimination", icon: "Scale", description: "Unfair treatment based on who you are." },
  { value: "retaliation", label: "Retaliation", icon: "TriangleAlert", description: "Negative consequences for raising a concern." },
  { value: "facilitated_conversation", label: "Facilitated Conversation", icon: "MessagesSquare", description: "Request a neutral, guided conversation." },
  { value: "other", label: "Something Else", icon: "CircleHelp", description: "Any other workplace concern you'd like to share." },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.value, c]));

export const STATUSES = [
  { value: "new", label: "New", badge: "bg-gold/15 text-charcoal-700 border border-gold/40" },
  { value: "triaged", label: "Triaged", badge: "bg-[#5C7B89]/15 text-[#3d5560] border border-[#5C7B89]/30" },
  { value: "investigating", label: "Investigating", badge: "bg-forest-600/12 text-forest-700 border border-forest-600/25" },
  { value: "resolved", label: "Resolved", badge: "bg-[#4A7c59]/15 text-[#356343] border border-[#4A7c59]/30" },
  { value: "closed", label: "Closed", badge: "bg-charcoal-600/10 text-charcoal-700 border border-charcoal-600/20" },
];

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.value, s]));

export const PRIORITIES = [
  { value: "low", label: "Low", badge: "bg-forest-50 text-forest-700 border border-forest-200" },
  { value: "medium", label: "Medium", badge: "bg-gold/15 text-charcoal-700 border border-gold/40" },
  { value: "high", label: "High", badge: "bg-terracotta-100 text-terracotta-600 border border-terracotta-300/60" },
  { value: "urgent", label: "Urgent", badge: "bg-destructive/12 text-destructive border border-destructive/30" },
];

export const PRIORITY_MAP = Object.fromEntries(PRIORITIES.map((p) => [p.value, p]));

export const CAMPUSES = [
  "North Campus",
  "South Campus",
  "East Campus",
  "West Campus",
  "Downtown Campus",
  "Online Campus",
  "All Campuses / Not Sure",
];

export const CONTACT = {
  email: "er-coe@patria.church",
  phone: "(555) 123-4567",
};
